// var defaultApi = '//devtest.sys.hollardchina.com.cn';
var defaultApi = "//busitest.sys.hollardchina.com.cn";
// defaultApi = "http://f7984ce8.natappfree.cc/sys";
let defaultImg = "//applyimage.hollardchina.com.cn/";
if (process.env.VUE_APP_FLAG === "dev" || process.env.VUE_APP_FLAG == "") {
	// 开发环境
	// defaultApi = '//devtest.sys.hollardchina.com.cn';
	defaultApi = "//busitest.sys.hollardchina.com.cn";
	// defaultApi = "http://f7984ce8.natappfree.cc/sys";
} else if (process.env.VUE_APP_FLAG === "busi") {
	// 测试环境
	defaultApi = "//busitest.sys.hollardchina.com.cn";
} else if (process.env.VUE_APP_FLAG === "prod") {
	// 生产环境
	defaultApi = "//systp.hollardchina.com.cn";
}
class Init {
	apis = {
		default: defaultApi, // 默认
		defaultImg: defaultImg,
	};
	token = {
		accessToken: "",
		refreshToken: "",
	};
	userRole = [];
	user = {}; // 用户
	role = {}; // 角色
	btnIds = []; // 按钮id集合
	menu = []; // 菜单

	/**
	 * 获取菜单树
	 */
	getMenuTree() {
		var tree = [];
		let getSon = (id) => {
			return this.menu.filter((e) => {
				if (e.parentId == id) {
					e.son = getSon(e.id);
					return e;
				}
			});
		};
		tree = getSon("0", tree);
		return tree;
	}

	/**
	 * 验证权限
	 * id = 菜单url + 按钮url
	 */
	hasPower(id) {
		return this.btnIds.indexOf(id) < 0 ? false : true;
	}

	/**
	 * 获取图片地址
	 * @param {*} name
	 * @returns 图片地址
	 */
	getFileUrl(name) {
		if (name) {
			return `${this.apis.default}/access/file/${name}`;
		}
		return "";
	}
}
export default Init;
